export default "__VITE_ASSET__TOWNdHKQ__"